/* GunMatch bridge: keeps the theme's gun memory working.
   When a shopper picks a gun in GunMatch, write the same cookies the old Make/Model bar wrote
   (uch_make / uch_model, exact firearm metaobject names, path=/), so holster product pages
   preselect the gun and unlock Add to Cart. Names come from gunmatch-firearm-map.js. */
(function () {
  if (typeof window.remember !== 'function' || typeof GUNS === 'undefined') return;

  var map = window.GM_FIREARM || {};
  var none = {};
  (window.GM_NOFIREARM || []).forEach(function (id) { none[id] = 1; });
  var last = '';

  function firearmFor(g) {
    if (!g || none[g.id]) return null;
    if (map[g.id]) return { make: map[g.id][0], model: map[g.id][1] };
    return { make: g.make, model: g.model };
  }

  // Same format as the theme's setCookie / YWM.setCookieForMinutes today: raw value, path=/, browser session.
  function setUchCookie(name, value) { document.cookie = name + '=' + value + ';path=/'; }
  function clearUchCookie(name) { document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/'; }

  var original = window.remember;
  window.remember = function () {
    original.apply(this, arguments);
    try {
      var g = S.g;
      if (!g || g.id === last) return;
      last = g.id;
      var f = firearmFor(g);
      if (!f) return; // gun not on the site yet: leave the product page in its normal "select your firearm" state
      setUchCookie('uch_make', f.make);
      setUchCookie('uch_model', f.model);
      clearUchCookie('uch_size'); // a size picked earlier would override the new gun on product pages
    } catch (e) {}
  };
  // GunMatch Searched (Klaviyo): the page opened with ?gmq= or #gun= (an email link) and the visitor is known to Klaviyo.
  // Sent once per page load, after the gun resolves, through window.klaviyo.track only (it carries the identity from _kx or
  // the cookie); no klaviyo.track = nothing sent. A search the slim bar forwarded (?gmsrc=bar) is a typed search, not a link.
  try {
    var qs = new URLSearchParams(location.search), hs = new URLSearchParams(location.hash.slice(1));
    var fromLink = (!!qs.get('gmq') && qs.get('gmsrc') !== 'bar') || !!hs.get('gun');
    if (fromLink) {
      var hasKx = !!qs.get('_kx');
      var cookieKnown = (function () {
        try {
          var m = document.cookie.match(/(?:^|; )__kla_id=([^;]*)/); if (!m) return false;
          var raw = decodeURIComponent(m[1]), j = null;
          try { j = JSON.parse(atob(raw)); } catch (e) { try { j = JSON.parse(raw); } catch (e2) { j = null; } }
          return !!(j && (j.$exchange_id || j.$email));
        } catch (e) { return false; }
      })();
      var sentSearch = false, t0 = Date.now();
      var trySend = function () {
        if (sentSearch) return true;
        var k = window.klaviyo, g = S.g;
        if (!g) return Date.now() - t0 > 6000; // never resolved from the link: give up; a later typed pick is not this event
        if (!k || typeof k.track !== 'function') return Date.now() - t0 > 10000;
        var send = function () {
          if (sentSearch) return; sentSearch = true;
          try { k.track('GunMatch Searched', { gun_id: g.id, gun_name: mk(g) + ' ' + short(S.variant || base(g.model)), source: 'email link' }); } catch (e) {}
        };
        if (hasKx || cookieKnown) { send(); return true; }
        var known = null;
        try { known = typeof k.isIdentified === 'function' ? k.isIdentified() : null; } catch (e) { known = null; }
        if (known && typeof known.then === 'function') { known.then(function (yes) { if (yes) send(); }, function () {}); return true; }
        if (known === true) send();
        return true;
      };
      var iv = setInterval(function () { if (trySend()) clearInterval(iv); }, 250);
    }
  } catch (e) {}
  // Search typed in the slim bar on another page (/?gmq=...): run it here
  try {
    var q = new URLSearchParams(location.search).get('gmq');
    var box = document.getElementById('q'), form = document.getElementById('form');
    if (q && box && form && !S.g) { box.value = q; form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })); }
  } catch (e) {}
})();
